// src/data/servicesData.js

export const servicesData = [
  {
    name: "Plant Supply",
    path: "/services/plant-supply",
    image: "/images/plants.jpg",
    description:
      "A wide range of healthy, high-quality plants for homes, offices, and landscapes.",
  },
  {
    name: "Pots Supply",
    path: "/services/pots-supply",
    image: "/images/pots.jpg",
    description:
      "Durable and stylish pots in ceramic, terracotta, fiberglass, and more.",
  },
  {
    name: "Indoor Plant Setup",
    path: "/services/indoor-plant",
    image: "/images/indoorplants.jpg",
    description:
      "Customized indoor plant arrangements designed for beauty and air purification.",
  },
  {
    name: "Kitchen Garden",
    path: "/services/kitchen-garden",
    image: "/images/kitchengarden.jpg",
    description:
      "Homegrown vegetables and herbs with complete kitchen garden setup support.",
  },
  {
    name: "Garden Care & Maintenance",
    path: "/services/maintenance",
    image: "/images/maintenance.jpeg",
    description:
      "Professional maintenance to keep landscapes healthy, clean, and beautiful.",
  },
  {
    name: "Artificial Lawn",
    path: "/services/artificial-lawn",
    image: "/images/artificiallawn.jpg",
    description:
      "Lush, green artificial lawns for indoor and outdoor spaces with minimal maintenance.",
  },
  {
    name: "Vertical Garden",
    path: "/services/vertical-garden",
    image: "/images/verticalgarden.webp",
    description:
      "Living walls that transform blank surfaces into vibrant, natural ecosystems.",
  },
  {
    name: "Drip Irrigation",
    path: "/services/drip-irrigation",
    image: "/images/dripirrigation.webp",
    description:
      "Efficient watering systems that deliver water directly to plant roots.",
  },
];
